import moment from 'moment'

const MAX_TIME_DIFF = 15
/**
 * @description Determines whether the user is online now
 * @param lastOnline, the time string of when the suer was the last online
 * @param listingPath, the path to the listing
 * @returns boolean the boolean that indicates whether the user is online
 */
export const IsOnlineNow = (lastOnline, listingPath) => {
  const upgradedNeededToSeeListing = listingPath === '/upgrade'
  const curTime = moment()
  const lastOnlineTime = moment(lastOnline)
  const timeDiffMins = curTime.diff(lastOnlineTime, 'minutes')
  return !upgradedNeededToSeeListing && timeDiffMins < MAX_TIME_DIFF
}
